import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, currentUser, authLoading } = useAuth();
  const location = useLocation();

  // Wait for auth to finish loading before making decisions
  if (authLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Check authentication from context (not localStorage)
  if (!isAuthenticated) {
    // Only remember TourGuideDashboard; everything else goes to dashboard after login
    if (location.pathname === '/tour-guide') {
      localStorage.setItem('returnUrl', '/tour-guide');
    } else {
      // Ensure no stale or unwanted returnUrl remains
      localStorage.removeItem('returnUrl');
    }
    return <Navigate to="/login" replace />;
  }

  // Prevent guests from accessing guide/dashboard routes
  if (currentUser?.role === 'guest' && !location.pathname.startsWith('/tour-participant')) {
    console.warn('[ProtectedRoute] Guest attempted to access restricted route:', location.pathname);
    return <Navigate to="/" replace />;
  }

  // Check role-based access
  if (requiredRole && currentUser?.role !== requiredRole) {
    console.warn('[ProtectedRoute] User lacks required role:', requiredRole);
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default ProtectedRoute;